import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class APIInterceptor implements HttpInterceptor {
    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let outgoing = req;

        const pageUrl = new URL(this.document.location.href);
        const host = pageUrl.hostname;

        if (!host.includes('diensten') && !host.includes('localhost') && req.url.startsWith('/services')) {
            outgoing = req.clone({ url: `/diensten${req.url}` });
        }

        return next.handle(outgoing);
    }
}
